import { IconName } from 'components/Icon/icon-names'

type Brands = {
  id: string
  name: string
  icon: IconName
}

export const brands: Brands[] = [
  {
    id: 'MASTERCARD',
    name: 'Mastercard',
    icon: 'mastercard',
  },
  { id: 'VISA', name: 'Visa', icon: 'visa' },
  {
    id: 'AMEX',
    name: 'American Express',
    icon: 'amex',
  },
  {
    id: 'HIPERCARD',
    name: 'Hipercard',
    icon: 'hipercard',
  },
  {
    id: 'ELO',
    name: 'Elo',
    icon: 'elo',
  },
  {
    id: 'DINERS',
    name: 'Diners Club',
    icon: 'diners',
  },
  {
    id: 'CREDZ',
    name: 'Credz',
    icon: 'credz',
  },
  {
    id: 'SOROCRED',
    name: 'Sorocred',
    icon: 'sorocred',
  },
  {
    id: 'JCB',
    name: 'JCB',
    icon: 'jcb',
  },
  {
    id: 'AGIPLAN',
    name: 'Agiplan',
    icon: 'agi',
  },
  {
    id: 'CABAL',
    name: 'Cabal',
    icon: 'cabal',
  },
  {
    id: 'BANESCARD',
    name: 'Banescard',
    icon: 'banescard',
  },
  {
    id: 'CREDSYSTEM',
    name: 'Credsystem',
    icon: 'credsystem',
  },
]

export const CREDIT_CARD_EXPIRY_DATE_LENGTH = 4
export const CURRENT_MILLENIUM = 2000
export const FORMAT_ISVALID = /^[0-9]{2,}$/
export const CHARCODE_0 = '0'.charCodeAt(0)
export const MAPPING_EVEN = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9]
export const MINIMUM_CVV_LENGTH = 3
